import { NotificationType } from '../../enums/notification-type.enum';
import { ObjectUtil } from '../../utility/object.util';
import { BaseNotificationModel } from './base-notification.model';

export class LastSurveyNotificationModel extends BaseNotificationModel {
    public rep: string;
    public client: string;
    public feedback: string;
    public repRate: number;
    public lgfgRate: number;

    public constructor(data?: any, type?: NotificationType) {
        super(data);
        ObjectUtil.extend(data, this);
        this.type = type;
    }
}